/**
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:SOCIAL
 */

  /**
   * @class ShareLinks
   *
   * Renders a list containing social sharing links.
   * (e.g. facebook, pinterest, G+, twitter).
   *
   * Also renders link to external site (e.g. designer's personal site)
   *   but this link is not tracked through GA
   *
   */
/*
  UMD header generated via modularize.js at 2015-04-14T23:57:21.205Z
  assumed dependencies: _gaq
*/
var module;
UMD(module,
  {
    'minted:m': ['M'],
    'minted:vendor/backbone-1.0.0.min': 'Backbone',
    'minted:vendor/jquery-1.9.1.min': '$',
    'minted:vendor/underscore-1.8.2.min': '_',
    'minted:constants': [],
    'minted:base': [],
    'minted:util/instrumented_element': []
  }
)(this, function (m_module, Backbone, $, _) {

  var M = m_module.M;

  M.View = M.View || {};
  M.View.ShareLinks = Backbone.View.extend({
    options: {
      bustCache: true,
      trackingParams: false,
      enableTwitter: false,
      // enable link to external site - opens in separate tab,
      // untracked in GA
      enableExternalSite: false,
      // useNewIcons specifies to use new style icons (gray color scheme)
      // icons are specified using css in sass/social.scss
      useNewIcons: false,
      // {String} One of the constants from M.GA.SHARE_MEDIUM
      medium: M.GA.SHARE_MEDIUM.DEFAULT_MEDIUM,
      // {String} One of the constants from M.GA.SHARE_CAMPAIGN
      campaign: M.GA.SHARE_CAMPAIGN.DEFAULT_CAMPAIGN,
      story: {
        description: '',
        url: '',
        imageUrl: ''
      },
      socialTrackingIdentifier: '0',
      socialTrackingPageType: '0',
      socialTrackingPrefix: '',
      el: $('<div />')
    },

    TYPES: {
      // [identifier] : { Identifier used for element class
      //    key: String to match key on M.GA.SHARE_SOURCE
      //    name: String of human readable name for display/tooltip
      //    w,h: Integers width and height of popup dialog
      //    urlTpl: Backbone template string for url generation
      // Note: externalSite type has a simple url so doesn't need
      //    click / url handling specs here
      'facebook': {key: 'FACEBOOK', name: 'Facebook', w: 930, h: 540,
        urlTpl: 'https://www.facebook.com/sharer.php?u=<@= url @>'},
      'twitter': {key: 'TWITTER', name: 'Twitter', w: 500, h: 400,
        urlTpl: 'https://twitter.com/intent/tweet?url=<@= url @>' +
          '&amp;text=<@= description @>'},
      'pinterest': {key: 'PINTEREST', name: 'Pinterest', w: 665, h: 300,
        urlTpl: 'https://pinterest.com/pin/create/button/?url=<@= url @>' +
          '&amp;media=<@= imageUrl @>&amp;description=<@= description @>'}
    },

    templates: {
      list: _.template(
        '<ul class="socialShareLinks linkCount<@= links.length @>">' +
          '<@ _.each(links, function(thisLink, index){ @>' +
            '<li class="<@= M.html.htmlAttributeEscape(thisLink) @>' +
                '<@= (index === links.length - 1 ? " last" : "") @>' +
                '<@= (useNewIcons ? " new border" : "") @> ">' +
              '<@= html[index] @>' +
            '</li>' +
          '<@ }); @>' +
        '</ul>'),
      singleExtSite: _.template(
        '<a target="_blank" href="http://<@= href @>" rel="nofollow"' +
          ' data-type="<@= type @>"></a>')
    },

    initialize: function() {
      // Ensure underscore template settings are correct for this script!
      var storedSettings = _.templateSettings;
      _.templateSettings = {
        'interpolate': /<@=([\s\S]+?)@>/gm,
        'evaluate': /<@([\s\S]+?)@>/gm,
        'escape': /<@-([\s\S]+?)@>/gm
        };

      if (M.IS_MOBILE_OPTIMIZED) {
        this.templates.single =  _.template('<a class="socialMediaClickTgt" target="minted_<@= type @>_share"' +
          ' href="<@= href @>" title="Share on <@= name @>"' +
          ' data-type="<@= type @>">' +
        '<@= name @></a>')
      } else {
        this.templates.single =  _.template('<a class="socialMediaClickTgt" target="minted_<@= type @>_share"' +
          ' href="<@= href @>" title="Share on <@= name @>"' +
          ' data-type="<@= type @>">' +
        'Share on <@= name @></a>')
      }

      this.render();

      // Return underscore template settings to their original values
      _.templateSettings = storedSettings;
    },

    events: {
      // social media icons need to generate popups so this functionality
      // handled by linkClick()
      'click .socialMediaClickTgt': 'linkClick'
    },

    render: function() {
      // NOTE: this.el is NOT set for this view; it uses this.options.el
      // Determine which links to show
      var links=['facebook', 'pinterest'];
      var html=[];

      if(this.options.enableTwitter) {
        links.push('twitter');
      }
      if (this.options.enableExternalSite) {
        links.push('externalSite');
      }
      for(var i=0; i<links.length; ++i){
        html.push(this.getSingle(links[i]));
      }

      this.options.el.append(this.templates.list(
        {links: links, html: html, useNewIcons: this.options.useNewIcons}));

      this.addInstrumentationList(links);
      return this;
    },

    _getActionName: function(linkStr) {
      var actionStr = null;
      switch (linkStr) {
        case 'facebook':
          actionStr =
            'M.GA.TRACK_EVENT_ACTION.SHARE_ON_FACEBOOK_ICON_CLICK';
          break;
        case 'pinterest':
          actionStr =
            'M.GA.TRACK_EVENT_ACTION.SHARE_ON_PINTEREST_ICON_CLICK';
          break;
        case 'twitter':
          actionStr =
            'M.GA.TRACK_EVENT_ACTION.SHARE_ON_TWITTER_ICON_CLICK';
          break;
        case 'externalSite':
          actionStr =
            'M.GA.TRACK_EVENT_ACTION.SHARE_ON_EXTERNAL_SITE_ICON_CLICK';
          break;
      };
      return actionStr;
    },

    addInstrumentationList: function(links) {
      var that = this;
      _.each(links, function(linkStr) {
        var $parentElement = that.options.el.find('.' + linkStr);
        if ($parentElement.length === 1) { // should only be 1 of each link
          // Figure out the action string based on social media type
          var actionStr = that._getActionName(linkStr);
          var $instrumentElement = $parentElement.find('.socialMediaClickTgt');
          if (actionStr) {
            $instrumentElement.addClass(
              M.InstrumentedElement.prototype.CLASS_TAG);
            $instrumentElement.attr('data-' +
              M.InstrumentedElement.prototype.DATA_EVENT_SPEC_KEY,
              'click');
            $instrumentElement.attr('data-' +
              M.InstrumentedElement.prototype.DATA_ACTION_KEY,
              actionStr);
          }
        }
      });
    },

    linkClick: function(e){
      e.preventDefault();
      var dataType = $(e.currentTarget).attr('data-type')
      var cType = this.TYPES[dataType];
      window.open(e.currentTarget.href, e.currentTarget.target,
        'height=' + cType.h + ',width=' + cType.w +
        ',toolbar=0,resizable=yes,scrollbars=yes,location=0');
      M.View.ShareLinks.trackSocial(
        this.options.socialTrackingPrefix + M.GA.SHARE_SOURCE[cType.key],
        this.options.socialTrackingPageType,
        M.GA.TRACK_SOCIAL_ACTION_TYPE[cType.key],
        this.options.socialTrackingIdentifier);

      if (this._getActionName(dataType)) {
        // this._getActionName(dataType) will always in format
        // "M.GA.TRACK_EVENT_ACTION.SHARE_ON_TWITTER_ICON_CLICK"
        var actionNameSplit = this._getActionName(dataType).split(".");
        var eventName =
          M.GA.TRACK_EVENT_ACTION[actionNameSplit[3]];
        var data = {
          feature: this.options.socialTrackingPrefix.replace("_", ""),
          event: eventName,
          sku: this.options.socialTrackingIdentifier
        };
        M.sendTrackAPI(data);
      }
    },

    getSingle: function(type) {
      var href = '';
      var cType = null;
      var templateOutput = '';

      if (type == 'externalSite') {
        // If external site icon, then it's just a simple url link
        href = this.options.story.extUrl;
        templateOutput = this.templates.singleExtSite({type: type, href: href});
      } else {
        // If social media icon, then we need to add tracking / etc
        href = this.getURL(type);
        cType = this.TYPES[type];
        templateOutput = this.templates.single(
          {type: type, href: href, name: cType.name});
      }
      return templateOutput;
    },

    getURL: function(type){
      // Validate Type Value
      if(!this.TYPES.hasOwnProperty(type)){
        throw 'Invalid share link type!';
      }

      var cType = this.TYPES[type];
      var urlToShare = this.addTrackingParametersToURL(
          this.options.story.url, M.GA.SHARE_SOURCE[cType.key]);
      var separator = urlToShare.indexOf('?') >= 0 ? '&' : '?';

      //Add parameter to clear cache if specified
      urlToShare += this.options.bustCache ?
         (separator + 't=' + new Date().getTime()) : '';

      return _.template(cType.urlTpl)({
          url: encodeURIComponent(urlToShare),
          imageUrl: encodeURIComponent(this.options.story.imageUrl),
          description: encodeURIComponent(this.options.story.description)
        });
    },

    addTrackingParametersToURL: function(url, type) {
      if (this.options.trackingParams) {
        var separator = url.indexOf('?') >= 0 ? '&' : '?';
        url += separator + 'utm_source=' +
          encodeURIComponent(type) +
          '&utm_medium=' +
          encodeURIComponent(this.options.medium) +
          '&utm_campaign=' +
          encodeURIComponent(this.options.campaign);
      }
      return url;
    }

  }, // Static methods
  {
    trackSocial: function(network, pageType, actionType, identifier) {
      _gaq.push(['_trackSocial',
        network,
        'Share']);
      // Internal tracking
      $.ajax({
        type: 'POST',
        url: '/track_social',
        data: {
         'page_type': pageType,
         'action_type': actionType,
         'identifier': identifier
        }
      });
      return false;
    }
  });

  return {};
});
